import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React from "react";
export var TenantEventContext = React.createContext({
    tenantId: null,
    eventId: null,
});
// This component will be used to provide tenantId and eventId to the context
export var TenantEventProvider = function (_a) {
    var tenantId = _a.tenantId, eventId = _a.eventId, children = _a.children;
    console.log("TenantEventProvider: tenantId=".concat(tenantId, ", eventId=").concat(eventId));
    return (_jsx(TenantEventContext.Provider, { value: { tenantId: tenantId, eventId: eventId }, children: children }));
};
